<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Mixpanel_Field_ProjectToken')"
        prop="params.api_token"
        :hint="$t('Integrations_Mixpanel_Field_ProjectToken_Hint')"
      >
        <el-input
          v-model="model.params.api_token"
          :placeholder="$t('Integrations_Mixpanel_Field_ProjectToken')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Mixpanel_Field_ResidencyServer')"
        prop="params.region"
      >
        <enum-select
          v-model="model.params.region"
          :options="ServerRegions"
          :placeholder="$t('Integrations_Mixpanel_Field_ResidencyServer')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { ServerRegions } from '@/modules/integrations/types/mixpanel/ResidencyServerRegionsEnum'
export default {
  name: 'MixpanelSettings',
  components: {
    EnumSelect,
    FormSection,
    RestFormItem
  },
  data() {
    return {
      ServerRegions,
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          api_token: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          region: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/mixpanel/MixpanelSettings.vue